import React, { Fragment, memo } from 'react';

function toNum(value, step) {
	if(typeof value === 'string') {
		if(step === 1) {
			value = value.replace(/[^0-9]+/g, '');
		} else {
			value = value.replace(/[^0-9.,]+/g, '');
		}
	} else if(typeof value === 'number' && step === 1) {
		value = Math.floor(value);
	}
	if(!isNaN(value)) {
		return +value;
	}
	return value;
}

function ColliInput({ set, p, type, className, ...props }) {
	if(props.required && !p.colli[type]) {
		className += ' is-invalid';
	}
	const integer = props.step === 1;
	if(integer) {
		props.inputmode = 'numeric';
		props.pattern = '[0-9]*';
	} else {
		props.type = 'number';
		props.min = 0;
	}
	return <input
		{...props}
		className={className}
		onChange={set(p.i, type, props.step)}
		value={p.colli[type] || ''} />;
}

function SandwichInput({ set, p, pallets }) {
	let type = 'EU';
	for(const key in p.colli.packingAids) {
		type = key;
		break;
	}
	const quantity = p.colli.packingAids[type] || '';
	return <>
		<div className="col-sm-2">Sandwich</div>
		<div className="col-sm-4">
			<select value={type} onChange={set(p.i, 'packingAids', 'key')} className="form-control">
				{pallets.reduce((o, pallet) => {
					if(pallet.sandwichable) {
						o.push(<option value={pallet.id} key={pallet.id}>{pallet.name}</option>);
					}
					return o;
				}, [])}
			</select>
		</div>
		<div className="col-sm-2">Quantity</div>
		<div className="col-sm-4">
			<input type="number" step={1} min={0} className="form-control" value={quantity} onChange={set(p.i, 'packingAids', 'value')} placeholder="Quantity" />
		</div>
	</>;
}

function ColliForm({ pallet, className, byPallet, setColli, setPallet, warehouses, pallets, agents }) {
	function set(index, key, type) {
		return e => setColli(c => {
			const copy = c.slice();
			let { value } = e.target;
			if(key === 'packingAids') {
				if(type === 'key') {
					value = { [value]: Object.values(c[index][key])[0] || 0 };
				} else if(type === 'value') {
					const quantity = toNum(value, 1);
					value = { ...c[index][key] };
					for(const p in value) {
						value[p] = quantity;
					}
				} else if(e.target.checked) {
					value = { EURO: 1 };
				} else {
					value = undefined;
				}
			} else if(key !== 'warehouse') {
				value = toNum(value, type);
			}
			copy[index] = { ...c[index], [key]: value };
			return copy;
		});
	}
	const highlight = pallet.carriers.some(c => agents.includes(c));
	return <>
		<div className="col-sm-4 font-weight-bold">{pallet.name}</div>
		<div className="col-sm-8">
			<input
				className={highlight ? `${className} highlight-agent` : className}
				type="number"
				min={0}
				step={1}
				onChange={e => setPallet(pallet.id, toNum(e.target.value || 0, 1))}
				value={byPallet[pallet.id] ? byPallet[pallet.id].length : ''} />
		</div>
		{byPallet[pallet.id] && <>
			{pallet.type === 'PALLET' && <>
				<div className="col-sm-1 d-none d-sm-block"></div>
				<div className="col-sm-4 d-none d-sm-block">Height (cm)</div>
				<div className="col-sm-4 d-none d-sm-block">Weight (kg)</div>
				<div className="col-sm-2 d-none d-sm-block">Warehouse</div>
				<div className="col-sm-1 d-none d-sm-block text-right">Sandwich</div>
			</>}
			{byPallet[pallet.id].map(p => {
				const sandwich = Boolean(p.colli.packingAids);
				return <Fragment key={p.i}>
					{pallet.type === 'BOX' && <>
						<div className="col-sm-8">Doos {p.i + 1}</div>
						<div className="col-sm-4"></div>
						<div className="col-sm-8">
							<div className="row">
								<div className="col-sm-4">
									<ColliInput className={className} set={set} p={p} type="length" step={1} placeholder="Length (cm)" required />
								</div>
								<div className="col-sm-4">
									<ColliInput className={className} set={set} p={p} type="width" step={1} placeholder="Width (cm)" required />
								</div>
								<div className="col-sm-4">
									<ColliInput className={className} set={set} p={p} type="height" step={1} placeholder="Height (cm)" required />
								</div>
							</div>
						</div>
					</>}
					{pallet.type === 'PALLET' && <>
						<div className="col-sm-1">{p.i + 1}</div>
						<div className="col-sm-4">
							<label className="d-block d-sm-none">Height (cm)</label>
							<ColliInput className={className} set={set} p={p} type="height" step={1} placeholder="Height (cm)" required />
						</div>
					</>}
					{pallet.type !== 'DIMENSIONLESS' && <div className="col-sm-4">
						{pallet.type === 'PALLET' && <label className="d-block d-sm-none">Weight (kg)</label>}
						<ColliInput className={className} set={set} p={p} type="weight" placeholder="Weight (kg)" required={pallet.type === 'BOX'} />
					</div>}
					<div className={pallet.type === 'PALLET' ? 'col-sm-2' : 'col-sm-12'}>
						<select value={p.colli.warehouse || ''} onChange={set(p.i, 'warehouse')} className="form-control">
							<option value="" disabled>Warehouse</option>
							{warehouses.map(w => <option value={w.value} key={w.value}>{w.label}</option>)}
						</select>
					</div>
					{pallet.type === 'PALLET' && <>
						<div className="col-sm-1 text-right"><input type="checkbox" checked={sandwich} onChange={set(p.i, 'packingAids')} /></div>
					</>}
					{sandwich && <SandwichInput set={set} p={p} pallets={pallets} />}
				</Fragment>;
			})}
		</>}
	</>;
}

function OrderPallets({ pallets, readonly, abc, colli, setPallet, setColli, dropship, byPallet, newStickersPrompt, setNewStickersPrompt, warehouses }) {
	const agents = [];
	const maxPallets = abc.reduce((all, { lines, maxPallets: max }) => {
		lines.forEach(line => {
			if(line.agent) {
				agents.push(line.agent);
			}
		});
		return Math.max(all, max);
	}, 0);
	const className = maxPallets && colli.length > maxPallets ? 'form-control is-invalid' : 'form-control';
	readonly ||= newStickersPrompt;
	return <div>
		{dropship ? <h3>Colli</h3> : <h3>
			Pallets
			{maxPallets > 0 && <small className="text-danger"> (Max. {maxPallets})</small>}
		</h3>}
		{newStickersPrompt && <p>
			Na een aanpassing aan de {dropship ? 'colli' : 'pallets'} <strong className="text-danger">moeten</strong> nieuwe stickers worden geplakt.{' '}
			<button onClick={e => {
				e.preventDefault();
				setNewStickersPrompt(false);
			}} className="btn btn-sm btn-primary">Bewerken</button>
		</p>}
		<div className="row">
			{!readonly && pallets.map(pallet => <ColliForm key={pallet.id} agents={agents} pallet={pallet} className={className} byPallet={byPallet} setColli={setColli} setPallet={setPallet} warehouses={warehouses} pallets={pallets} />)}
			{readonly && pallets.reduce((out, pallet) => {
				if(byPallet[pallet.id]) {
					if(pallet.type === 'DIMENSIONLESS') {
						out.push(<Fragment key={pallet.id}>
							<div className="col-sm-6 font-weight-bold">{pallet.name}</div>
							<div className="col-sm-6">{byPallet[pallet.id].length}</div>
						</Fragment>);
					} else {
						byPallet[pallet.id].forEach((p, i) => {
							const packingAids = [];
							if(p.colli.packingAids) {
								for(const key in p.colli.packingAids) {
									const qty = p.colli.packingAids[key];
									if(qty < 1) {
										continue;
									}
									const { name } = pallets.find(pa => pa.id === key);
									packingAids.push(`${qty}x ${name.replace('pallet', 'sandwichpallet')}`);
								}
							}
							out.push(<Fragment key={`${pallet.id}${i}`}>
								<div className="col-sm-6 font-weight-bold">{pallet.name}</div>
								<div className="col-sm-6">
									{pallet.type === 'BOX' ? <>{p.colli?.length} &times; {p.colli?.width} &times; {p.colli?.height}cm</> : <>{p.colli?.height}cm</>}
									, {p.colli?.weight}kg{packingAids.length ? ` + ${packingAids.join(' + ')}` : null}
								</div>
							</Fragment>);
						});
					}
				}
				return out;
			}, [])}
		</div>
	</div>;
}

export default memo(OrderPallets);
